import { models } from "../data/models";
import "../styles/ModelSelector.css";

const ModelSelector = ({ model, setModel }) => {
  const handleChange = (event) => {
    const selectedName = event.target.value;
    const selected = models.find((model) => model.name === selectedName);
    console.log("Selected:", selected);
    setModel(selected);
  };

  return (
    <div className="model-selector-container">
      <label htmlFor="modelSelector" className="model-selector-label">
        モデル :
      </label>
      <select
        id="modelSelector"
        key={model.name}
        value={model.name}
        onChange={handleChange}
        className="model-selector-select"
      >
        {models.map((model, index) => (
          <option key={index} value={model.name}>
            {model.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ModelSelector;
